export function stripNonValidPhoneCharacters(inputString: string) {
  const validPhonePattern = /[^\d()+\- ]/g;

  return inputString.replace(validPhonePattern, '');
}

export default stripNonValidPhoneCharacters;
